import $ from 'jquery'

import './app/setup'
import App from './app/app'

$(App)
